// src/App.js
import { BrowserRouter as Router } from "react-router-dom";
import { MainRoutedPage } from "./routes/app-routes";
import { AppNavBar } from "./components/app-nav";
import Footer from "./components/app-footer/footer";
import { useContext, useState } from "react";
import { UnderMaintenance } from "./pages/under-maintenance";
import { CognitoContext } from "./contexts/cognito/cognito-provider";
import { ToastProvider } from "./components/toast/toast-context";
import { ToastContainer } from "./components/toast/ToastContainer";
import { AppLoadingProvider } from "./components/layout/app-loading-provider";
import { AppLoadingOverlay } from "./components/layout/app-loading-overlay";

function App() {
  // useState(() => {
  //   const ua = navigator.userAgent || navigator.vendor || window.opera;
  //   const isApple = /Macintosh|MacIntel|MacPPC|Mac68K|iPhone|iPad|iPod|AppleWebKit/i.test(ua);
  //   if (
  //     navigator.mediaDevices &&
  //     navigator.mediaDevices.getUserMedia &&
  //     !isApple
  //   ) {
  //     navigator.mediaDevices.getUserMedia({ video: true })
  //       .then(() => {})
  //       .catch(() => {});
  //   }
  // }, []);
  const [redemptionCodeId, setRedemptionCodeId] = useState(null);
  const { state } = useContext(CognitoContext);
  const isLoggedIn = state.session && state.cognitoUser;

  if (process.env.REACT_APP_UNDER_MAINTENANCE?.toLocaleLowerCase() === "true") {
    return <UnderMaintenance />;
  }

  const signedInMargins = isLoggedIn ? "mt-20 sm:mt-[90px] md:ml-[6.5rem] bg-transparent" : "";

  return (
    <Router>
      <AppLoadingProvider>
        <ToastProvider position="top-center" duration={5000} maxToasts={3}>
          <div className="App overflow-y-hidden">
            {/* {isLoggedIn && <AppNavBar redeem={redemptionCodeId} />} */}

            <div className={`routed-page`}>
              <MainRoutedPage setRedemptionCode={setRedemptionCodeId} />
            </div>

            {/* {isLoggedIn && <Footer />} */}
          </div>

          <ToastContainer />
          <AppLoadingOverlay useGif blur />
        </ToastProvider>
      </AppLoadingProvider>
    </Router>
  );
}

export default App;
